import {
  AnalyticsEventType,
  DimensionValue,
  InsightsMetricSelectOption,
  MetricValue,
} from 'common/src/modules/analytics/analytics.types';
import _partition from 'lodash/partition';

export default function partitionByEventType(
  options: InsightsMetricSelectOption<DimensionValue | MetricValue>[],
  eventType = AnalyticsEventType.Adserving,
): [
  InsightsMetricSelectOption<DimensionValue | MetricValue>[],
  InsightsMetricSelectOption<DimensionValue | MetricValue>[],
] {
  return _partition(options, {eventType});
}
